import { setEmployeesList, setEmployeeRegister, handleLoading } from './actions';
import { fetchEmployees, fetchEmployeeRegister, fetchEmployeeByEmail } from './services';

export const loadEmployees = ({ page, qp = '', userId, establishmentId }) => dispatch => {
  let url = `${userId}/users?page=${page}${qp}`;

  if(establishmentId) {
    url = `${userId}/establishment/${establishmentId}/users?page=${page}${qp}`;
  }

  dispatch(handleLoading(true));

  return fetchEmployees(url)
    .then(({ data }) => {
      const newData = data.content.filter(item => {
        if (item.profileName !== 'Manobrista') {
          return item;
        }
      });
      dispatch(setEmployeesList(newData, newData.length));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadEmployeeRegister = (userId, registerId) => dispatch => {
  return fetchEmployeeRegister(userId, registerId)
    .then(({ data }) => dispatch(setEmployeeRegister(data)));
}

export const loadEmployeeByEmail = (userId, email) => dispatch => {
  dispatch(handleLoading(true));

  return fetchEmployeeByEmail(userId, email)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}